import BaseController from './BaseController'
import {
  action
} from 'mobx';

export default class ReportController extends BaseController {

  // 查询
  @action async search() {

  }

  // 上一页
  @action async pageUp() {

  }
  // 下一页
  @action async pageDown() {

  }

}
